import { AApi } from './AApi';
import type { ApiResult, PaginationBody, PaginationParams } from '../types/api.types';
import type { AiAnnouncementDetails, AiAnnouncementInput, AiAnnouncementListBody, AiRightsBody, AiUserBody } from '../types/ai.types';

/** The AI module: `/ai/announcements`, `/ai/users`, `/ai/rights`. */
export class AiApi extends AApi {
    public createAnnouncement(data: AiAnnouncementInput): Promise<ApiResult<AiAnnouncementDetails>> {
        return this.Client.post(this.announcements(), data);
    }

    public deleteAnnouncement(announcementId: number): Promise<ApiResult<undefined>> {
        return this.Client.delete(this.announcements(announcementId));
    }

    public getAnnouncement(announcementId: number): Promise<ApiResult<AiAnnouncementDetails>> {
        return this.Client.get(this.announcements(announcementId));
    }

    public getRights(): Promise<ApiResult<AiRightsBody>> {
        return this.Client.get(`${this.VersionPath}/ai/rights`);
    }

    public listAnnouncements(params?: PaginationParams): Promise<ApiResult<{ announcements: AiAnnouncementListBody[]; pagination?: PaginationBody }>> {
        return this.Client.get(`${this.announcements()}${this.toQuery(params)}`);
    }

    public listUsers(params?: PaginationParams): Promise<ApiResult<{ users: AiUserBody[]; pagination?: PaginationBody }>> {
        return this.Client.get(`${this.VersionPath}/ai/users${this.toQuery(params)}`);
    }

    public updateAnnouncement(announcementId: number, data: Partial<AiAnnouncementInput>): Promise<ApiResult<AiAnnouncementDetails>> {
        return this.Client.patch(this.announcements(announcementId), data);
    }

    private announcements(announcementId?: number): string {
        return `${this.VersionPath}/ai/announcements${announcementId === undefined ? '' : `/${announcementId.toString()}`}`;
    }
}
